import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";

import ListEcartReglement from "../../components/ListEcartReglement";
import { columns } from "./columns";

import { loadLocataires } from "../../store/actions/locataireAction";
import { loadLocations } from "../../store/actions/locationAction";
import { loadReglements } from "../../store/actions/reglementAction";
import { loadEcritures } from "../../store/actions/ecritureAction";

class EcartReglement extends Component {
  componentDidMount() {
    this.props.loadLocataires();
    this.props.loadLocations();
    this.props.loadReglements();
    this.props.loadEcritures();
  }

  render() {
    const { locataires, locations, reglements, ecritures } = this.props;

    return (
      <Spin
        spinning={!locataires || !locations || !reglements || !ecritures}
        size="large"
        tip="Chargement en cours..."
      >
        {locataires && locations && reglements && ecritures && (
          <ListEcartReglement
            listData={locataires}
            tableOption={columns}
            locations={locations}
            reglements={reglements}
            ecritures={ecritures}
          />
        )}
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadLocataires: () => dispatch(loadLocataires()),
    loadLocations: () => dispatch(loadLocations()),
    loadReglements: () => dispatch(loadReglements()),
    loadEcritures: () => dispatch(loadEcritures()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    locataires: state.locataires.data,
    locations: state.locations.data,
    reglements: state.reglements.data,
    ecritures: state.ecritures.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EcartReglement);
